import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';
import plugins from './plugins';
import { state } from './state';
import router from '../routes';
import { sync } from 'vuex-router-sync';

import auth from '@/core/shared/auth/store';
import core from '@/core/shared/web-panel/store';
import { generateId } from '@/core/shared/helpers/VariousHelper';
import dashboard from '@/dashboard/store';
import launcher from '@/launcher/store';
import healthCheckModule from '@/core/shared/vuex-modules/health/health-check-module';
import DefaultNotification from '@/launcher/components/shared/notifications/DefaultNotification';

// import location from '@/location/store'

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins,
  modules: {
    auth,
    core,
    dashboard,
    launcher,
    network: healthCheckModule,
    notifications: {
      state: {
        launcher: [],
      },
      mutations: {
        addNotification (state, { id, component, usage, props, type }) {
          state.launcher.push({
            id: generateId(),
            component,
            usage,
            props,
            type,
          });
        },
        replaceNotification (state, { id, component, usage, props, type }) {
          state.launcher = [{ id: generateId(), component, usage, props, type }];
        },
        removeLastNotification (state) {
          state.launcher.shift();
        },
        removeAllNotifications (state, { whitelist }) {
          if (whitelist) {
            state.launcher = state.launcher.filter(n =>
              whitelist.includes(n.type),
            );
          } else state.launcher = [];
        },
      },
      actions: {
        addNotification (
          { commit, dispatch },
          { component = DefaultNotification, usage, delay = 3000, props, type },
        ) {
          commit('addNotification', {
            component,
            props,
            usage,
            type,
          });
          if (delay) {
            setTimeout(() => dispatch('nextNotification'), delay);
          }
        },
        replaceNotification (
          { commit, dispatch },
          { component = DefaultNotification, usage, props, type },
        ) {
          commit('replaceNotification', {
            component,
            props,
            usage,
            type,
          });
        },
        nextNotification ({ commit }) {
          commit('removeLastNotification');
        },
        removeAllNotifications ({ commit }, { whitelist } = {}) {
          commit('removeAllNotifications', { whitelist });
        },
      },
    },
    // location,
  },
});

if (module.hot) {
  module.hot.accept(['./getters', './actions', './mutations'], () => {
    store.hotUpdate({
      getters: require('./getters'),
      actions: require('./actions'),
      mutations: require('./mutations'),
      modules: {
        core: require('@/core/shared/web-panel/store'),
        auth: require('@/core/shared/auth/store'),
        dashboard: require('@/dashboard/store'),
        launcher: require('@/launcher/store'),
        // location,
      },
    });
  });
}

sync(store, router);
export default store;
